import {useDispatch, useSelector } from 'react-redux';
import SocialIcons from '../components/Common/SocialIcons';
import Logo from '../assets/images/Logo.png';
import { Link } from 'react-router-dom';
import { globalSearchClose } from '../redux/slices/CommonSlice';
import { loginModalOpen } from '../redux/slices/AuthSlice';
import { ThunkDispatch } from '@reduxjs/toolkit';
import paths from '../routes/paths'; 


const  Footer = () => { 
	const {categories} = useSelector((state:any) => state.settings)
    const dispatch = useDispatch<ThunkDispatch<any,any,any>>();
	  const closeGlobalSearch = () => {
		dispatch(globalSearchClose());
	  }
	//const [loginModalShow, setLoginModalShow] = useState(false);


	const {loggedInUser} = useSelector((state:any) => state.auth)
	//console.log("ddddddddddddddddd",loginModalShow)
  return (

			<footer className="site-footer  style-1  bg-light">
				<div className="footer-top">
					<div className="container">
						<div className="row">
							<div className="col-xl-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
								<div className="widget widget_about me-2">
									<div className="footer-logo logo-dark">
										<a href="/"><img src={Logo} alt="logo"/></a> 
									</div>
									<ul className="widget-address">
										<li>
											<p><span>Address</span> : SR Nagar, Hyderabad, Telangana, India</p>
										</li>
										<li>
											<p><span>E-mail</span> : anuughacollections@gmail.com</p>
										</li>
										<li>
											<p><span>Whatsapp</span> : +91 84999 19988</p>
										</li>
									</ul>
									<div className="subscribe_widget">
										<h6 className="title fw-medium text-capitalize">subscribe to our newsletter</h6>	
											<form>
												<div className="dzSubscribeMsg"></div>
														<span id="subscribe-form-msg"></span>
												<div className="form-group">
													<div className="input-group mb-0">

														<input name="email"  type="email" className="form-control" placeholder="Your Email Address"/>
														<div className="input-group-addon">
															<button name="submit" value="Submit" type="submit" className="btn">
																<i className="icon feather icon-arrow-right"></i>
															</button>

														</div>
													</div>
												</div>
											</form>								 
									</div>
								</div>
							</div>
		
							<div className="col-xl-3 col-md-4 col-sm-6 col-6 wow fadeInUp" data-wow-delay="0.3s">
								<div className="widget widget_services">
									<h5 className="footer-title">Top Categories</h5>
									<ul>
										{categories.map((category) => 
											<li key={"category_menu_" + category.slug}> 
												<Link to={paths.subCategories(category.slug)} onClick={() =>  closeGlobalSearch()} className="stext-107 cl7 hov-cl1 trans-04">{category.name}</Link>
											</li>
										)}
										<li> <a href="/subcategories/fancy-sarees" className="stext-107 cl7 hov-cl1 trans-04">  Fancy Sarees </a></li>
									</ul>   
								</div>
							</div>
							<div className="col-xl-3 col-md-4 col-sm-6 col-6 wow fadeInUp" data-wow-delay="0.4s">
								<div className="widget widget_services">
									<h5 className="footer-title">Useful Links</h5>
									<ul> 

										<li className="p-b-10">
										<Link to={paths.contactUs}   className="stext-107 cl7 hov-cl1 trans-04">Contact Us</Link>
										</li> 
										<li className="p-b-10">
										<Link to={paths.shippingPolicy}  className="stext-107 cl7 hov-cl1 trans-04">Shipping Policy</Link>
										</li>
										<li className="p-b-10">
										<Link to={paths.returnExchangePolicy}  className="stext-107 cl7 hov-cl1 trans-04">Return & Exchange Policy</Link>
										</li>
										<li className="p-b-10">
											<Link to={paths.privacyPolicy} className="stext-107 cl7 hov-cl1 trans-04" >Privacy Policy</Link> 
										</li>
										<li className="p-b-10">
											<Link  to={paths.termsConditions}  className="stext-107 cl7 hov-cl1 trans-04">Terms & Conditions</Link>
										</li>
									</ul>
								</div>
							</div>
							<div className="col-xl-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
								<div className="widget widget_services">
									<h5 className="footer-title">Footer Menu</h5>
									<ul>
										<li><Link to={paths.store} onClick={() =>  closeGlobalSearch()}>New Arrivals</Link> </li>
										<li><Link to={paths.offers} onClick={() =>  closeGlobalSearch()}>Offers</Link> </li>
										<li><Link to={paths.tracking} onClick={() =>  closeGlobalSearch()}>Track Order</Link> </li> 
										{loggedInUser === null && (
											<li><span className='adminLoginLink' onClick={() =>   dispatch(loginModalOpen('Admin'))}>Admin Login</span> </li> 
										)}
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div> 
				<div className="footer-bottom">
					<div className="container">
						<div className="row fb-inner wow fadeInUp" data-wow-delay="0.1s">
							<div className="col-lg-6 col-md-12 text-start"> 
								<p className="copyright-text">© <span className="current-year">{new Date().getFullYear()}</span> <a href="https://www.anuughacollections.com/">www.anuughacollections.com</a> . All Rights Reserved.</p>
							</div>
							<div className="col-lg-6 col-md-12 text-end"> 
									<div className="d-flex align-items-center justify-content-center justify-content-md-center justify-content-xl-end">
										<span className="me-3">Please follow us: </span>
										<SocialIcons/>
									</div>
								</div>
						</div>
					</div>
				</div>
		


				<button className="scroltop" type="button"><i className="fa fa-arrow-up"></i></button> 
			</footer> 

	
  );
}

export default Footer;

 
